import { makeDownstreamApiCall, HTTP_METHODS } from "@swiggy-private/checkout-core";
import { AppRedirectionInfo } from "@swiggy-private/payment-types";

// Endpoint constants
export const INSTAMART_PAYMENT_ENDPOINTS = {
    INITIATE: "/api/v3/initiatePayment",
    CONFIRM: "/api/v3/confirmPayment",
};

export enum PaymentTransactionState {
    STATE_SUCCESS = "STATE_SUCCESS",
    STATE_PENDING = "STATE_PENDING",
    STATE_FAIL = "STATE_FAIL",
    STATE_INVALID = "STATE_INVALID",
    STATE_INIT = "STATE_INIT",
}

export enum PaymentContext {
    PAYMENT_CONTEXT_INVALID = "PAYMENT_CONTEXT_INVALID",
    PAYMENT_CONTEXT_TRACK_PAGE_PAYMENT = "PAYMENT_CONTEXT_TRACK_PAGE_PAYMENT",
}

export interface Money {
    currencyCode?: string;
    units?: string;
    nanos?: number;
}

export interface PaymentTransaction {
    paymentId?: string;
    marketplaceReferenceId?: string;
    totalAmount?: Money;
    state?: PaymentTransactionState;
    paymentContext?: PaymentContext;
}

export interface TransactionEntry {
    paymentTxnStatus: string;
    amazonPayResponse?: { amazonPayLoad: Record<string, string> };
    paymentMethodMeta?: unknown;
    paymentPartnerOrderId?: string;
    paymentTxnId?: string;
    confirmationTimeInMinutes?: string;
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface InstamartInitiatePaymentRequest {
    order_id: string;
    payment_info: {
        payment_method: string;
        metadata: string;
        transaction_amount: number;
    };
    [key: string]: unknown;
}

export interface InstamartInitiatePaymentParams {
    payment_cod_method?: string;
    transaction_amount?: string | number;
    payment_info?: {
        metadata?: string;
    };
}

export interface InstamartPaymentResponse {
    paymentId?: string;
    paymentMethodRedirect?: AppRedirectionInfo;
    payment?: PaymentTransaction;
}

export interface InstamartConfirmPaymentRequest {
    order_id: string;
    payment_id: string;
    no_refund_confirmation?: boolean;
    [key: string]: unknown;
}
/* eslint-enable @typescript-eslint/naming-convention */

export async function initiateInstamartPayment(
    apiHost: string,
    request: InstamartInitiatePaymentRequest,
    headers: Record<string, string>,
): Promise<InstamartPaymentResponse> {
    const response = await makeDownstreamApiCall<InstamartPaymentResponse>({
        apiHost,
        endpoint: INSTAMART_PAYMENT_ENDPOINTS.INITIATE,
        bodyParams: request,
        options: {
            method: HTTP_METHODS.POST,
            headers,
        },
    });

    return response as InstamartPaymentResponse;
}

export async function confirmInstamartPayment(
    apiHost: string,
    request: InstamartConfirmPaymentRequest,
    headers: Record<string, string>,
): Promise<InstamartPaymentResponse> {
    const response = await makeDownstreamApiCall<InstamartPaymentResponse>({
        apiHost,
        endpoint: INSTAMART_PAYMENT_ENDPOINTS.CONFIRM,
        bodyParams: request,
        options: {
            method: HTTP_METHODS.POST,
            headers,
        },
    });

    return response as InstamartPaymentResponse;
}
